import { INSTANCE_URL, PROXY_URL } from '../constants';
import { getUserCredentials } from './userCredentials';
import jsforce from 'jsforce';
import { getUserSession, setUserSession } from './userSession';

export const getSalesforceConnectionByAccessToken = ({
  instanceUrl,
  accessToken,
}) => {
  return new jsforce.Connection({ instanceUrl, accessToken });
};

export const getSalesforceConnectionByCredentials = () => {
  return new jsforce.Connection({
    loginUrl: INSTANCE_URL,
    proxyUrl: PROXY_URL,
  });
};

export const refreshSession = async () => {
  const userSession = getUserSession();

  if (userSession) {
    getSalesforceConnectionByAccessToken(userSession);
  }

  const userCredentials = getUserCredentials();
  if (!userCredentials) {
    throw new Error('no credentials');
  }

  const conn = getSalesforceConnectionByCredentials();
  await conn.login(userCredentials.email, userCredentials.password);
  setUserSession(conn);
  return conn;
};

export const getSalesforceConnection = async (
  { instanceUrl, accessToken },
  shouldRefreshConnection
) => {
  if (shouldRefreshConnection) {
    return await refreshSession();
  }
  console.log(instanceUrl);
  return getSalesforceConnectionByAccessToken({ instanceUrl, accessToken });
};
